module.exports = __webpack_public_path__ + "assets/img/selected.aaff3159.svg";